import React, { useEffect, useState } from 'react';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Text from '@amzn/meridian/text';
import Checkbox from '@amzn/meridian/checkbox';
import { FormattedMessage, useIntl } from 'react-intl';
import { TRAILING_DAYS } from './LighthouseMetrics/types';
import {
  Feature,
  isFeatureEnabled,
  updateSpecificFeatureFlag,
} from '../../../config/FeaturesConfig';

interface MetricsUseHistoricalDataModalProps {
  weekValue: String;
  isManager: boolean;
}

export const MetricsUseHistoricalDataModal = ({
  weekValue,
  isManager,
}: MetricsUseHistoricalDataModalProps) => {
  const intl = useIntl();

  const historicalMetricsModalLocalStorageValue = isFeatureEnabled(
    Feature.DONT_SHOW_HISTORICAL_METRICS_MODAL
  );
  const isHistoricalMetricsFeatureEnabled = isFeatureEnabled(
    Feature.HISTORICAL_METRICS
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (
      weekValue != TRAILING_DAYS &&
      isManager && // only show modal to managers
      isHistoricalMetricsFeatureEnabled &&
      !historicalMetricsModalLocalStorageValue
    ) {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  }, [weekValue]);

  function onClickGotItButton() {
    if (checked) {
      updateSpecificFeatureFlag(
        Feature.DONT_SHOW_HISTORICAL_METRICS_MODAL,
        true
      );
    }
    setIsModalOpen(false);
  }

  return (
    <Modal
      title={
        <FormattedMessage
          id='cs_perfportal_historical_team_level_metrics_modal_title'
          defaultMessage='Metrics use historical data'
        />
      }
      open={isModalOpen}
      onClose={onClickGotItButton}
      closeLabel='Close'
      width={500}
    >
      <Text id='cs_perfportal_historical_team_level_metrics_modal_text'>
        {
          <FormattedMessage
            id='cs_perfportal_historical_team_level_metrics_modal_text'
            defaultMessage='To preserve the accuracy of aggregated team data, team-level metrics include data from all associates who were on the team during the seleced timeframe. Associate-level metrics only reflect associates who are on the team currently.'
          />
        }
      </Text>
      <br />
      <Row>
        <Checkbox checked={checked} onChange={setChecked}>
          {
            <FormattedMessage
              id='cs_perfportal_historical_team_level_metrics_modal_dont_show_message_again'
              defaultMessage="Don't show this message again"
            />
          }
        </Checkbox>
      </Row>
      <ModalFooter>
        <Row alignmentHorizontal='end' widths='fit'>
          <Button type='primary' size='small' onClick={onClickGotItButton}>
            {
              <FormattedMessage
                id='cs_perfportal_historical_team_level_metrics_modal_got_it_button'
                defaultMessage='Got it'
              />
            }
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};
